import ButtonAsync from '../../ui/button/ButtonAsync';
import Modal, { ModalProps } from '../../ui/modal/Modal';
import Button, { ButtonThemes } from '../../ui/button/Button';
import { ErrorHandler } from '../../contexts/error-handler/ErrorHandler';
import style from './FileListActionsModal.module.scss';
import { ModalSizeType } from '@danfoss/mosaic-core';

export type DocumentUpdateModalProps = {
    modal?: ModalProps;
    children: React.ReactNode;

    isOpen: boolean;

    close: {
        isDisabled?: boolean;
        label: string;
        onClick: (source: 'action' | 'modal') => void;
    };

    submit: {
        label: string;
        isDisabled?: boolean;
        onClick: () => Promise<void>;
    };

    errorId: string;
    size?: ModalSizeType;
    closeOnEscape?: boolean;
    closeOnBackdropClick?: boolean;
};

const FileListActionsModal: React.FC<DocumentUpdateModalProps> = ({ modal, children, isOpen, close, submit, errorId, closeOnEscape = true, closeOnBackdropClick = true, size = 'medium' }) => {
    return (
        <Modal
            closeOnEscape={closeOnEscape}
            closeOnBackdropClick={closeOnBackdropClick}
            isOpen={isOpen}
            className={style['file-list-actions-modal']}
            onClose={() => close.onClick('modal')}
            size={size}
            {...modal}
            body={(
                <>
                    {children}
                    <ErrorHandler.Notification id={errorId} />
                </>
            )}
            footer={(
                <>
                    {close && <Button {...close} onClick={() => close.onClick('action')} theme={ButtonThemes.textPrimary} />}
                    {submit && <ButtonAsync {...submit} />}
                </>
            )}
        />
    );
};

export default FileListActionsModal;